import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  getChoiceLinesParent,
  getPatternOfStudy,
  getSonePersonalDetails,
  getStudyPeriodsCodesDescription,
  putStudentPatternOfStudy,
  updateEnrolment } from '../../services/vu'
import {
  addVirtualUnits,
  getActiveEnrolledDualInstanceCalendarTypeUnits,
  getActiveEnrolledSingleInstanceCalendarTypeUnits,
  getAttributeCourseStaticInfo,
  getEnrolledUnits,
  getFlattenedUnitsWithMultipleAttendanceModes,
  getUnitsWithMultipleAttendanceModes,
  getYearsEnrolled,
  hasDuplicates,
  isStudentOnLeave,
  removeVirtualUnitsOverlappingRealUnits,
  unitInstanceCount
} from '../../helpers/enrolment'
import { unitLocationStartDate, unitWithdrawalDate } from '../../helpers/unitDropDateHelper'
import EnrolmentGuide from '../tags/EnrolmentGuide'
import EnrolmentContainer from '../tags/EnrolmentContainer'
import StudentDeclaration from '../tags/StudentDeclaration'
import UnitStatus from '../../enums/UnitStatus'
import UnitStage from '../../enums/UnitStage'
import BlockType from '../../enums/BlockType'
import ResidencyType from '../../enums/ResidencyType'
import PatternAssociationStatus from '../../enums/PatternAssociationStatus'
import Sidenote from '../tags/Sidenote'
import { getProperty } from '../../helpers/properties'
import { CustomModal } from '../tags/Modals/Modal'
import ErrorModal from '../tags/Modals/ErrorModal'
import { Route } from 'react-router-dom'
import { getConfiguration } from '../../helpers/configuration'
import EnrolmentsTabs from '../tags/EnrolmentsTabs'
import ChoiceLines from '../tags/ChoiceLines/ChoiceLines'
import { processUnitAddErrors } from '../../helpers/errors'
import AllSettled from '../../enums/AllSettled'

class ManageEnrolment extends Component {
  constructor(props) {
    super(props)

    let defaultYear = sessionStorage.getItem("DEFAULT_YEAR");
    defaultYear = defaultYear === null ? getYearsEnrolled()[0] : defaultYear
    
    this.state = {
      courseId: '',
      courseTitle: '',

      currentEnrolment: [],
      enrolledUnits: [],
      coursePatternId: null,
      selectedEnrolmentYear: defaultYear,

      submitting: false,

      loadingUnits: true,
      apiCallFailed: false,
      hasBlockStatus: false,
      blockMode: '',

      requiresEnrolmentGuide: 'N',
      studyPackages: [],
      loadingEnrolmentGuide: false,

      myvuLink: getProperty('myVuSiteUrl'),

      defaultLocation: '',
      admissionCategory: '',
      availabilityYear: null,
      patternDetails: [],
      personalDetails: null,
      choiceLinesParent: [],
      putPatterOfStudyResponse: [],

      hasCoursePatternsFlag: 'N',
      courseYear: null,
      strictPatternStudent: false,
      academicYear: null,
      putPatternOfStudySuccessful: false,
      enrollingAcademicYear: null,
      showDropDatePassedConfirmationModal: false,
      dropDateSubmissionConfirmation: false,
      reloadEnrolmentGuide: false,
      reloadChoiceLineParents: false,
      reOpenModal: false,
      openEnrolmentErrorModel: false,
      enrolmentErrors: [],
      enrolmentErrorsPartialSuccess: false,
      unitsRemoved: [],
      studyPeriods: []
    }
  }

  componentDidMount() {
    putStudentPatternOfStudy(getAttributeCourseStaticInfo('parentSSPNo'), this.state.selectedEnrolmentYear)
      .then(putPatterOfStudyResponse => {
        let putPatterOfStudy = [...this.state.putPatterOfStudyResponse, putPatterOfStudyResponse];

        let newState = {
          putPatterOfStudyResponse: putPatterOfStudy,
          availabilityYear: putPatterOfStudyResponse.academicYear,
          coursePatternId: putPatterOfStudyResponse.patternId,
          patternStatus: putPatterOfStudyResponse.associationStatus,
          strictPatternStudent: putPatterOfStudyResponse.strictPatternFlag === 'Y',
          putPatternOfStudySuccessful:
                putPatterOfStudyResponse.associationStatus === PatternAssociationStatus.MANUALLYASSOCIATED ||
                putPatterOfStudyResponse.associationStatus === PatternAssociationStatus.ASSOCIATED,
          requiresEnrolmentGuide: putPatterOfStudyResponse.patternId === '',
          unspecifiedAdvanceStandingFlag: putPatterOfStudyResponse.unspecifiedAdvanceStandingFlag,
        }

        Promise.allSettled([
          getPatternOfStudy(getAttributeCourseStaticInfo('parentSSPNo')),
          getSonePersonalDetails(),
          getChoiceLinesParent(getAttributeCourseStaticInfo('parentSSPNo'), this.state.selectedEnrolmentYear),
          getStudyPeriodsCodesDescription()
        ])
          .then(([getPatternOfStudyResponse, sonePersonalDetailsResponse, choiceLineParentResponse, studyPeriods]) => {
            let apiFailed = false;

            if (getPatternOfStudyResponse.status === AllSettled.REJECTED ||
                sonePersonalDetailsResponse.status === AllSettled.REJECTED ||
                choiceLineParentResponse.status === AllSettled.REJECTED ||
                studyPeriods.status === AllSettled.REJECTED) {
                  apiFailed = true;
                newState = {
                  ...newState,
                  loadingUnits: false,
                  apiCallFailed: true
                }
              } else {
                if (getPatternOfStudyResponse.status === AllSettled.FULFILLED) {
                  newState = {
                    ...newState,
                    patternDetails: getPatternOfStudyResponse.value,
                  }
                }

                if (sonePersonalDetailsResponse.status === AllSettled.FULFILLED) {
                  newState = {
                    ...newState,
                    personalDetails: sonePersonalDetailsResponse.value
                  }
                }

                if (choiceLineParentResponse.status === AllSettled.FULFILLED) {
                  newState = {
                    ...newState,
                    choiceLinesParent: choiceLineParentResponse.value.information
                  }
                }
        
                if (studyPeriods.status === AllSettled.FULFILLED) {
                  newState = {
                    ...newState,
                    studyPeriods: studyPeriods.value.referenceCodes,
                  }
                }

            }

            this.setState({
              ...newState
            })

            if (!apiFailed) {
              this.initialiseEnrolledUnits()
            }
          })
      })
      .catch(() => {
        this.setState({
          loadingUnits: false,
          apiCallFailed: true
        })
      })

    window.addEventListener('beforeunload', this.displayUnconfirmedUnitsWarning)
  }

  componentDidUpdate(prevProps, prevState) {

    if (
      prevState.selectedEnrolmentYear !== this.state.selectedEnrolmentYear &&
      this.state.patternDetails.some(patternDetail => patternDetail.academicYear !== parseInt(this.state.selectedEnrolmentYear)) &&
      this.state.putPatterOfStudyResponse.some(patternDetail => patternDetail.academicYear !== parseInt(this.state.selectedEnrolmentYear))
    ) {
      putStudentPatternOfStudy(getAttributeCourseStaticInfo('parentSSPNo'), this.state.selectedEnrolmentYear)
        .then(putPatterOfStudyResponse => {
          let putPatterOfStudy = [...this.state.putPatterOfStudyResponse, putPatterOfStudyResponse];

          Promise.all([
            getPatternOfStudy(getAttributeCourseStaticInfo('parentSSPNo')),
            getSonePersonalDetails(),
            getChoiceLinesParent(getAttributeCourseStaticInfo('parentSSPNo'), this.state.selectedEnrolmentYear)
          ])
            .then(([getPatternOfStudyResponse, sonePersonalDetailsResponse, choiceLineParentResponse]) => {
              this.setState({
                putPatterOfStudyResponse: [...this.state.putPatterOfStudyResponse, putPatterOfStudyResponse],
                availabilityYear: putPatterOfStudyResponse.academicYear,
                coursePatternId: putPatterOfStudyResponse.patternId,
                patternStatus: putPatterOfStudyResponse.associationStatus,
                strictPatternStudent: putPatterOfStudyResponse.strictPatternFlag === 'Y',
                putPatternOfStudySuccessful:
                  putPatterOfStudyResponse.associationStatus === PatternAssociationStatus.MANUALLYASSOCIATED ||
                  putPatterOfStudyResponse.associationStatus === PatternAssociationStatus.ASSOCIATED,
                requiresEnrolmentGuide: putPatterOfStudyResponse.patternId === '',
                unspecifiedAdvanceStandingFlag: putPatterOfStudyResponse.unspecifiedAdvanceStandingFlag,
                patternDetails: getPatternOfStudyResponse,
                personalDetails: sonePersonalDetailsResponse,
                choiceLinesParent: choiceLineParentResponse.information,
                selectedEnrolmentYear: this.state.selectedEnrolmentYear
              })

              this.initialiseEnrolledUnits()
            })
            .catch(() => {
              this.setState({
                loadingUnits: false,
                apiCallFailed: true
              })
            })
        })
        .catch(() => {
          this.setState({
            loadingUnits: false,
            apiCallFailed: true
          })
        })
    } else if (this.state.reloadEnrolmentGuide && !prevState.reloadEnrolmentGuide) {
      this.initialiseEnrolledUnits()
    } else if (this.state.reloadChoiceLineParents && !prevState.reloadChoiceLineParents) {
      this.setState({
        loadingUnits: true
      })
      Promise.all([
        getChoiceLinesParent(getAttributeCourseStaticInfo('parentSSPNo'), this.state.selectedEnrolmentYear),
        getEnrolledUnits(getAttributeCourseStaticInfo('parentSSPNo'), this.state.coursePatternId, this.state.patternStatus)
      ])
        .then(([choiceLineParentResponse, units]) => {
          this.setState({
            loadingUnits: true,
            reloadChoiceLineParents: false,
            choiceLinesParent: choiceLineParentResponse.information,
            ...this.processEnrolledUnitsCall(units)
          })
        })
        .catch(() => {
          this.setState({
            loadingUnits: false,
            reloadChoiceLineParents: false,
            apiCallFailed: true
          })
        })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.displayUnconfirmedUnitsWarning)
  }

  setSelectedEnrolmentYear = (year) => {
    this.setState({
      selectedEnrolmentYear: year
    })
  }

  processEnrolledUnitsCall = units => {
    let unitSet = []
    if (getAttributeCourseStaticInfo('blockCode') === BlockType.FourWeekBlock || getAttributeCourseStaticInfo('blockCode') === BlockType.EightWeekBlock) {
      let virtualUnitSet = addVirtualUnits(units)
      unitSet = removeVirtualUnitsOverlappingRealUnits(virtualUnitSet)
    } else {
      unitSet = units
    }
    return {
      currentEnrolment: Array.from(unitSet),
      enrolledUnits: unitSet,
      loadingUnits: false,
      defaultLocation: getAttributeCourseStaticInfo('locationCode'),
      admissionCategory: getAttributeCourseStaticInfo('admissionCategory'),
      blockCode: getAttributeCourseStaticInfo('blockCode'),
      courseTitle: getAttributeCourseStaticInfo('courseTitle'),
      courseCode: getAttributeCourseStaticInfo('courseCode')
    }
  }

  reloadChoiceLineParents = (reOpenModal = false) => {
    getChoiceLinesParent(getAttributeCourseStaticInfo('parentSSPNo'), this.state.selectedEnrolmentYear)
      .then(choiceLineParentResponse => {
        this.setState({
          choiceLinesParent: choiceLineParentResponse.information,
          reloadEnrolmentGuide: true,
          reOpenModal: reOpenModal
        })
      })
      .catch(() => {
        this.setState({
          apiCallFailed: true,
          reloadEnrolmentGuide: true,
          reOpenModal: false
        })
      })
  }

  /**
   * @returns {Array}
   */
  getEnrolledUnits = () => {
    return this.state.enrolledUnits
  }

  displayUnconfirmedUnitsWarning = event => {
    const hasUnconfirmedUnits = this.getEnrolledUnits().some(unit => {
      return unit.unitStatus === UnitStatus.PLANNED
    })

    const hasRemovedUnit = this.getRemovedUnits()

    if (hasUnconfirmedUnits || hasRemovedUnit) {
      event.returnValue = this.getNavigateAwayText()
      return this.getNavigateAwayText()
    }
  }

  /**
   * Dispatch error to the screen.
   * @param {*} errorText error message.
   */
    dispatchEnrolmentErrorModel = (enrolmentErrors = [], partialSuccess = false, unitsRemoved) => {
      this.setState({
        submitting: false,
        loadingUnits: false,
        showDropDatePassedConfirmationModal: false,
        openEnrolmentErrorModel: true,
        enrolmentErrors: enrolmentErrors,
        unitsRemoved: unitsRemoved,
        submitting: false
      })
      // alert(errorText)
      // this.handleCloseSuggestionModal()
    }

    /**
   * Handle closing of the suggestion modal.
   */
    handleCloseEnrolmentErrorModal = (enrolmentUpdating = false) => {
      this.setState({
        openEnrolmentErrorModel: false
      })

      this.initialiseEnrolledUnits(this.state.unitsRemoved)
    }

  getNavigateAwayText = () => {
    return `You have unconfirmed units in your enrolment. Please click '${this.getNavigateText()}' to confirm your enrolment before exiting.`
  }

  getNavigateText = () => {
    return 'Return to MyVU'
  }

  getSubmitButtonText = () => {
    return 'Submit enrolment'
  }

  onEnrolmentUpdated = () => {
    this.setState({
      reloadChoiceLineParents: true
    })
  }

  initialiseEnrolledUnits = callback => {
    this.setState({
      loadingUnits: true
    })
    getEnrolledUnits(getAttributeCourseStaticInfo('parentSSPNo'), this.state.coursePatternId, this.state.patternStatus).then(units => {
      let unitSet = []
      if (getAttributeCourseStaticInfo('blockCode') === BlockType.FourWeekBlock || getAttributeCourseStaticInfo('blockCode') === BlockType.EightWeekBlock) {
        let virtualUnitSet = addVirtualUnits(units)
        unitSet = removeVirtualUnitsOverlappingRealUnits(virtualUnitSet)
      } else {
        unitSet = units
      }
      this.setState({
        currentEnrolment: Array.from(unitSet),
        enrolledUnits: unitSet,
        loadingUnits: false,
        defaultLocation: getAttributeCourseStaticInfo('locationCode'),
        admissionCategory: getAttributeCourseStaticInfo('admissionCategory'),
        blockCode: getAttributeCourseStaticInfo('blockCode'),
        courseTitle: getAttributeCourseStaticInfo('courseTitle'),
        courseCode: getAttributeCourseStaticInfo('courseCode')
      })
      if (callback) {
        callback()
      }
    })
  }

  handleUpdatingUnits = (isLoadingUnits = false) => {
    this.setState({
      loadingUnits: isLoadingUnits
    })
  }

  /**
   * Get all the enrolled units that have not been discontinued.
   *
   * @return {Array}
   */
  getActiveEnrolledUnits = () =>
    this.getEnrolledUnits().filter(
      unit =>
        (unit.unitStatus === UnitStatus.PLANNED && unit.unitStage === UnitStage.PLANNED) ||
        (unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED) ||
        (unit.unitStatus === UnitStatus.PASS && unit.unitStage === UnitStage.COMPLETED) ||
        (unit.unitStatus === UnitStatus.FAIL && unit.unitStage === UnitStage.COMPLETED)
    )

  getValidationErrors = () => {
    return (
      //  this.getHasDoubleUppedBlockUnits() ||
      this.getHasDuplicateEnrolledUnits()
      //  this.getHasMoreBlockUnitsThanExpected()
    )
  }

  getBlockPatternData = () => {
    return this.state.patternDetails.find(patternDetail => patternDetail.academicYear === parseInt(this.state.selectedEnrolmentYear))
  }

  getIfUnitsContainEnrolledUnits = () => {
    return this.getActiveEnrolledUnits().find(unit => unit.unitAvailabilityYear === parseInt(this.state.selectedEnrolmentYear) && unit.unitStatus === UnitStatus.ENROLLED)
  }
  /**
   * Checks the student's enrolment to see if they have double-upped an
   * enrolment for a particular block model calendar type, e.g. SEM-1-B1.
   *
   * @return {boolean}
   */
  getHasDoubleUppedBlockUnits = (calendarType = 'FourWeek', attendanceModeCheck) => {
    // Creates a array of strings from the actively enrolled block model units
    // into the following pattern:
    //
    // 2018-SEM-1-B1
    // 2018-SEM-1-B2
    //
    // If there is a duplicate string in the array for Four week or more than two for eight week blocks
    //  then we have more units enrolled than allowed into the respective block model period.
    const enrolledUnits =
      calendarType === 'FourWeek'
        ? getActiveEnrolledSingleInstanceCalendarTypeUnits(this.getActiveEnrolledUnits().filter(unit => unit.unitAvailabilityYear === parseInt(this.state.selectedEnrolmentYear)))
        : getActiveEnrolledDualInstanceCalendarTypeUnits(this.getActiveEnrolledUnits().filter(unit => unit.unitAvailabilityYear === parseInt(this.state.selectedEnrolmentYear)))
    const filteredSameBlockUnits = attendanceModeCheck
      ? enrolledUnits.filter(unit => unit.virtual !== true && unit.removed !== true)
      : getFlattenedUnitsWithMultipleAttendanceModes(enrolledUnits.filter(unit => unit.virtual !== true && unit.removed !== true))
    const unitCalendarArray = filteredSameBlockUnits.map(unit => `${unit.unitAvailabilityYear}-${unit.unitAvailabilityStudyPeriodCode}`)
    let maxInstances = calendarType === 'FourWeek' ? 1 : 2
    return hasDuplicates(unitCalendarArray, maxInstances)
  }

  getHasDuplicateEnrolledUnits = () => {
    const filteredSameBlockUnits = getFlattenedUnitsWithMultipleAttendanceModes(this.getMutableUnits().filter(unit => unit.virtual !== true))

    const unitCodeArray = filteredSameBlockUnits.map(unit => unit.unitCode)

    let unitInstances = unitInstanceCount(unitCodeArray)

    const yearWiseUnits = filteredSameBlockUnits.filter(unit => unit.unitAvailabilityYear === parseInt(this.state.selectedEnrolmentYear))

    return yearWiseUnits.some(unit => unitInstances[unit.unitCode] > 1)
  }

  changeUnitUndoState = (unit, isRemoved) => {
    let enrolledUnits = this.state.enrolledUnits
    //using common method
    //TODO change prereq as no preresq is required
    enrolledUnits.forEach(enrolledUnit => {
      if (
        enrolledUnit.unitAvailabilityStudyPeriodCode === unit.unitAvailabilityStudyPeriodCode &&
        enrolledUnit.unitAvailabilityYear === unit.unitAvailabilityYear &&
        enrolledUnit.unitCode === unit.unitCode
      ) {
        enrolledUnit.removed = isRemoved
      }
    })
    this.setState({
      enrolledUnits: enrolledUnits
    })
  }

  //aligning with drop date text in the earlier context
  dropDatePassed = () => {
    return this.getActiveEnrolledUnits().some(
      unit =>
        (unit.unitStatus === UnitStatus.PLANNED || unit.unitStatus === UnitStatus.ENROLLED) &&
        unit.unitAvailabilityYear === parseInt(this.state.selectedEnrolmentYear) &&
        new Date(unitWithdrawalDate(unit)) < unitLocationStartDate(unit) &&
        new Date(unitWithdrawalDate(unit)) <= new Date()
    )
  }

  handleSubmit = () => {
    this.setState(
      {
        submitting: true
      },
      () => {
        if (this.getHasDoubleUppedBlockUnits('FourWeek', false) || this.getHasDoubleUppedBlockUnits('EightWeek', false)) {
          this.handleSubmissionError(
            'Your enrolment has more than one unit in one 4 Week Teaching Block and/or more ' +
              'than two units in one 8 Week Teaching Block. Please review your enrolment. For any assistance contact VUHQ.'
          )
          return
        }

        const unitsWithMultipleAttendanceModes = getUnitsWithMultipleAttendanceModes(
          this.getActiveEnrolledUnits().filter(
            unit => unit.unitAvailabilityYear === parseInt(this.state.selectedEnrolmentYear) && unit.unitStatus === UnitStatus.PLANNED && unit.virutal !== true
          )
        )

        if (unitsWithMultipleAttendanceModes.length > 0) {
          this.handleSubmissionError('You will need to select delivery for the following units before you can submit your enrolment: ' + unitsWithMultipleAttendanceModes.join())
          return
        }

        // Stop processing the form if we have duplicate unit codes in our
        // enrolment
        if (this.getHasDuplicateEnrolledUnits()) {
          this.handleSubmissionError('Please ensure that you have not selected the same unit more than once.')
          return
        }

        if (this.dropDatePassed() && !this.state.dropDateSubmissionConfirmation) {
          this.setState({
            showDropDatePassedConfirmationModal: true
          })
          return
        }

        const unitsToBeSubmitted = this.state.enrolledUnits.filter(
          unit => unit.unitStatus === UnitStatus.PLANNED && unit.removed !== true && unit.virtual !== true && unit.unitAvailabilityQuotaRemaining > 0 && unit.unitAvailabilityYear === parseInt(this.state.selectedEnrolmentYear)
        )

        let payload = {
          courseCode: getAttributeCourseStaticInfo('courseCode'),
          courseVersion: getAttributeCourseStaticInfo('versionNumber'),
          courseAttemptNumber: getAttributeCourseStaticInfo('attemptNumber'),
          parentSspNo: getAttributeCourseStaticInfo('parentSSPNo'),
          academicYear: this.state.selectedEnrolmentYear,
          units: unitsToBeSubmitted
        }

        let patternOfStudy = this.getBlockPatternData()

        if (patternOfStudy) {
          payload = {
            ...payload,
            patternId: this.getBlockPatternData() ? this.getBlockPatternData().patternId : '',
            patternStatus: this.getBlockPatternData() ? this.getBlockPatternData().associationStatus : ''
          }
        }

        updateEnrolment(payload)
          .then((responses = []) => {
            this.setState({
              submitting: false
            })
            this.initialiseEnrolledUnits()
            this.progressForm()
          })
          .catch((error) => {
            let responseData = error.response.data

            const unitsRemoved = this.state.enrolledUnits
              .filter(unit => unit.unitStatus === UnitStatus.PLANNED && unit.removed === true)
              .map(unit =>  unit.spkNumber +"-" +unit.unitCode)

            this.dispatchEnrolmentErrorModel(error.response.data.unitErrors, responseData.partialSuccess, unitsRemoved)
            //this.handleSubmissionError('System has encountered an error. Please try again or contact VUHQ for assistance.')
          })
      }
    )
  }

  handleSubmissionError = errorMessage => {
    this.setState({
      submitting: false,
      showDropDatePassedConfirmationModal: false
    })
    alert(errorMessage)
  }

  // VUS-69: Filter out units from the Big Payload where offerInd or
  // ivrsAvailableInd are not "Y" or are virtual
  getSubmittableUnits = () => {
    return this.getMutableUnits()
      .filter(({ unitManagementEnrolment, virtual }) => unitManagementEnrolment === 'Y' && virtual !== true)
      .filter(
        ({ unitStatus }) =>
          //TODO check if we need to submit only planned ones? or all enrolled ones as well
          unitStatus != null
      )
  }

  getMutableUnits = () => {
    return this.getActiveEnrolledUnits().filter(
      unit =>
        (unit.unitStatus === UnitStatus.PLANNED && unit.unitStage === UnitStage.PLANNED) ||
        (unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED) ||
        (unit.unitStatus === UnitStatus.PASS && unit.unitStage === UnitStage.COMPLETED)
    )
  }

  progressForm = () => {
    window.removeEventListener('beforeunload', this.displayUnconfirmedUnitsWarning)
    let baseUrl = this.state.myvuLink
    if (!baseUrl.endsWith('/')) {
      baseUrl += '/'
    }

    window.location = baseUrl + 'enrolments?success=true'
  }

  getIsBlockStatusStudent = () => this.state.blockCode === BlockType.FourWeekBlock || this.state.blockCode === BlockType.EightWeekBlock

  getRemovedUnits = () => {
    let removedUnit = this.state.enrolledUnits.filter(unit => unit.removed === true).length > 0
    return removedUnit
  }

  submitDropDateConfirmation = () => {
    this.setState({
      dropDateSubmissionConfirmation: true,
      showDropDatePassedConfirmationModal: false
    })
    this.handleSubmit()
  }

  getDropDateText = () => {
    const hasDropDate = this.getActiveEnrolledUnits().some(
      unit =>
        unit.unitAvailabilityYear === parseInt(this.state.selectedEnrolmentYear) &&
        (unit.unitStatus === UnitStatus.PLANNED || unit.unitStatus === UnitStatus.ENROLLED) &&
        new Date(unitWithdrawalDate(unit)) < unitLocationStartDate(unit)
    )

    return (
      hasDropDate && (
        <Sidenote>
          <div>
            <p>
              <strong>Important: </strong> Your enrolment contains at least one unit which has an early online withdraw deadline (noted below those units). If the deadline has passed, you
              will require college approval to make any amendment to those units. All other units follow the relevant study period Census dates. Refer to{' '}
              <a href="https://www.vu.edu.au/current-students/your-course/enrolment/change-your-enrolment/add-or-drop-units" target=" _blank">
                Enrolment Guidelines
              </a>
              .
            </p>
          </div>
        </Sidenote>
      )
    )
  }

  handleDropDateCloseModal = () => {
    this.setState({
      showDropDatePassedConfirmationModal: false,
      submitting: false
    })
  }

  isSubmitting = () => {
    return !this.state.submitting
  }

  handleChooseDeliveryUnit = unit => {
    this.setState({
      enrolledUnits: this.state.enrolledUnits
        .filter(
          enrolledUnit =>
            !(
              unit.unitCode === enrolledUnit.unitCode &&
              unit.unitAvailabilityYear === enrolledUnit.unitAvailabilityYear &&
              unit.unitAvailabilityLocationCode === enrolledUnit.unitAvailabilityLocationCode &&
              unit.unitAvailabilityStudyPeriodCode === enrolledUnit.unitAvailabilityStudyPeriodCode
            )
        )
        .concat(unit)
    })
  }

  setEnrolmentGuideStudyPackages = studyPackages => {
    this.setState({
      studyPackages: studyPackages
    })
  }

  setEnrolmentGuideLoading = loadingEnrolmentGuide => {
    this.setState({
      loadingEnrolmentGuide: loadingEnrolmentGuide,
      reloadEnrolmentGuide: false
    })
  }

  render() {
    return (
      <div className="manage-enrol">
        <div className="enrol-header">
          <div className="left">
            <div className="page-name">ENROL MODE</div>
          </div>
          <div className="right">
            <button className="btn btn-primary btn-submit" onClick={this.progressForm}>
              {this.getNavigateText()}
            </button>
            {/*<button className="btn btn-primary btn-cancel" onClick={this.progressForm}>Cancel</button>*/}
          </div>
        </div>

        <div className="content">
          <div className="title">
            <h1>My enrolment</h1>
            {!!this.state.courseTitle && (
              <h2>
                {this.state.courseTitle} {this.state.courseCode ? `[${this.state.courseCode}]` : ''}
              </h2>
            )}
          </div>
          {this.state.apiCallFailed ? (
            <div className="sidenote sidenote--error">
              <div className="sidenote__content">
                <p>
                  There seems to be an issue retrieving your data, please retry. Please{' '}
                  <a href="https://www.vu.edu.au/contact-us" target="_blank">
                    contact VUHQ
                  </a>{' '}
                  if you require assistance.
                </p>
              </div>
            </div>
          ) : isStudentOnLeave() ? (
            <div className="sidenote sidenote--error">
              <div className="sidenote__content">
                <p>
                  You have a current Leave of Absence record for this course, changes cannot be made to your enrolment during this time. Please{' '}
                  <a href="https://www.vu.edu.au/contact-us" target="_blank">
                    contact VUHQ
                  </a>{' '}
                  if you require assistance.
                </p>
              </div>
            </div>
          ) : (
            <div>
              {this.state.personalDetails && ResidencyType.International.includes(this.state.personalDetails.citizenshipCode) && getAttributeCourseStaticInfo('isOffshoreFlag') === 'N' ? (
                <Sidenote>
                  <div>
                    <p>
                      <strong>Important:</strong> As part of your visa requirements, you must complete your course with in the expected course duration as per your Confirmation of Enrolment
                      (COE).
                      <br />
                    </p>
                    <p>
                      To meet this requirement, you are encouraged to enrol in to full-time study load i.e. 48 Credit Points per semester. If you want to reduce your study load, you must
                      apply for a
                      <a href="https://www.vu.edu.au/sites/default/files/international/pdfs/FOR_Reduce-Study-For-Int-Students_A98_AU.pdf" target="_blank">
                        <strong>Reduced Study Load</strong>
                      </a>{' '}
                      form.
                    </p>
                  </div>
                </Sidenote>
              ) : null}

              {/* <Route path={getConfiguration('baseUrl') + '/manage/units'} render={props => <EnrolmentsTabs yearsEnrolled={getYearsEnrolled()} {...props} />} /> */}

              <EnrolmentsTabs yearsEnrolled={getYearsEnrolled()} setSelectedEnrolmentYear={this.setSelectedEnrolmentYear}>

              </EnrolmentsTabs>

              {(this.getBlockPatternData() ? (
                this.getBlockPatternData().associationStatus === PatternAssociationStatus.MANUALLYASSOCIATED ||
                this.getBlockPatternData().associationStatus === PatternAssociationStatus.ASSOCIATED
              ) : (
                false
              )) ? (
                <Sidenote>
                  <div>
                    {this.getIfUnitsContainEnrolledUnits() ? (
                      <p>
                        {' '}
                        Your enrolment has been pre-filled with prescribed units and you are enrolled in some units. To ensure you are enrolled in all units, click on Submit your Enrolment
                        on the bottom of the screen.
                      </p>
                    ) : (
                      <p>Your enrolment has been pre-filled with prescribed units. To ensure you are correctly enrolled, click on Submit your Enrolment on the bottom of the screen.</p>
                    )}
                    <p>You can review, make amendments and enroll into other units to to meet the requirements of your course.</p>
                    <p>
                      If you have any questions, please{' '}
                      <a href="https://www.vu.edu.au/contact-us" target="_blank">
                        contact VUHQ
                      </a>
                      .
                    </p>
                    {this.state.unspecifiedAdvanceStandingFlag === 'Y' && (
                      <p>
                        <strong>Note:</strong> You have Unspecified Advanced Standing credit towards your degree. Please ensure you check which units you are required to complete before
                        finalising your enrolment.
                      </p>
                    )}
                  </div>
                </Sidenote>
              ) : null}
              {this.getDropDateText()}
              {this.getValidationErrors() && (
                <div className="question-group">
                  <Sidenote className="sidenote--error">
                    <div>
                      {this.getHasDuplicateEnrolledUnits() && <p>You have added the same unit multiple times. Please remove the duplicate units before submitting your enrolment.</p>}
                    </div>
                  </Sidenote>
                </div>
              )}

              <div className={"pb5"}>
                <div className={"pt30"}>
                  To proceed with your enrolment, please add the required unit(s) within each semester block.
                </div>
                <div className={"pt24"}>
                  Refer to your{' '}
                  <a href="https://www.vu.edu.au/current-students/your-course/enrolment/course-delivery-plans/business-course-delivery-plans" target="_blank">
                    Course Delivery Plan
                  </a>{' '}
                  for further information on your course structure, electives and/or major(s) and minor(s) units required. Please note some units require you to meet certain prerequisites or
                  co-requisites for enrolment. If these requirements aren't met, you won't be able to add the unit.
                </div>
              </div>
              <ChoiceLines
                choiceLines={this.state.choiceLinesParent}
                selectionRequired={this.state.choiceLinesParent.filter(choiceLine => choiceLine.selectionRequired).length > 0}
                reloadChoiceLineParents={this.reloadChoiceLineParents}
                reOpenModal={this.state.reOpenModal}
              />
              {/*Enrolment*/}
              <EnrolmentContainer
                blockStatus={this.getIsBlockStatusStudent()}
                loadingUnits={this.state.loadingUnits}
                loadingEnrolmentGuide={this.state.loadingEnrolmentGuide}
                enrolledUnits={this.getEnrolledUnits().filter(
                  unit =>
                    (unit.unitStatus === UnitStatus.PLANNED && unit.unitStage === UnitStage.PLANNED) ||
                    (unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED) ||
                    (unit.unitStatus === UnitStatus.PASS && unit.unitStage === UnitStage.COMPLETED) ||
                    (unit.unitStatus === UnitStatus.FAIL && unit.unitStage === UnitStage.COMPLETED)
                )}
                currentEnrolment={this.state.currentEnrolment.filter(
                  unit =>
                    (unit.unitStatus === UnitStatus.PLANNED && unit.unitStage === UnitStage.PLANNED) ||
                    (unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED) ||
                    (unit.unitStatus === UnitStatus.PASS && unit.unitStage === UnitStage.COMPLETED) ||
                    (unit.unitStatus === UnitStatus.FAIL && unit.unitStage === UnitStage.COMPLETED)
                )}
                coursePatternId={this.state.coursePatternId}
                onEnrolmentUpdating={this.handleUpdatingUnits}
                onEnrolmentUpdated={this.onEnrolmentUpdated}
                defaultLocation={this.state.defaultLocation}
                changeUnitUndoState={this.changeUnitUndoState}
                handleChooseDeliveryUnit={this.handleChooseDeliveryUnit}
                isLastUnit={this.getActiveEnrolledUnits().filter(unit => unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED).length === 1}
                blockMode={this.state.blockCode}
                blockModelStudentPatternApplied={this.getBlockPatternData() ? this.getBlockPatternData().patternId !== '' : false}
                courseYear={this.state.courseYear}
                strictPattern={this.getBlockPatternData() ? this.getBlockPatternData().strictPatternFlag === 'Y' : false}
                firstPass={false}
                enrolYear={parseInt(this.state.selectedEnrolmentYear)}
                unspecifiedAdvanceStandingFlag={this.state.unspecifiedAdvanceStandingFlag}
                studyPackages={this.state.studyPackages}
                dispatchEnrolmentErrorModel={this.dispatchEnrolmentErrorModel}
                studyPeriods={this.state.studyPeriods}
              />

              <button onClick={this.handleSubmit} className="btn btn-lg btn-primary" disabled={this.state.submitting}>
                {this.state.submitting ? 'Submitting...' : this.getSubmitButtonText()}
              </button>
            </div>
          )}
        </div>
        {!this.state.apiCallFailed && !isStudentOnLeave() && (
          <EnrolmentGuide
            hasBlockStatus={this.state.hasBlockStatus}
            availabilityYear={this.state.selectedEnrolmentYear}
            prefillAttemptSuccessful={this.state.putPatternOfStudySuccessful}
            firstPass={true}
            setEnrolmentGuideStudyPackages={this.setEnrolmentGuideStudyPackages}
            setEnrolmentGuideLoading={this.setEnrolmentGuideLoading}
            reloadEnrolmentGuide={this.state.reloadEnrolmentGuide}
          />
        )}

        <ErrorModal
          title="Updating enrolments failed"
          isOpen={this.state.openEnrolmentErrorModel}
          handleCloseModal={this.handleCloseEnrolmentErrorModal}
          className="modal-xl"
          processErrors="false"
        >
          {processUnitAddErrors(this.state.enrolmentErrors, this.state.enrolmentErrorsPartialSuccess, "put_courses_coursecode_enrolments_general_exception")}
        </ErrorModal>

        <CustomModal
          className={'drop-date-confirmation-modal'}
          isOpen={this.state.showDropDatePassedConfirmationModal}
          userCanClose={true}
          handleCloseModal={this.handleDropDateCloseModal}
          title="Online withdraw deadline has passed"
        >
          <div className="question-group">
            <div className="form-items-group">
              Your enrolment contains at least one unit with an early online withdraw deadline that has passed. If you proceed, you will be unable to withdraw from those units without
              college approval.
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6 col-md-6">
              <button className="btn btn-lg btn-primary" onClick={this.submitDropDateConfirmation}>
                OK
              </button>
            </div>
            <div className="col-xs-6 col-md-6">
              <button className="btn btn-lg btn-primary" onClick={this.handleDropDateCloseModal}>
                CANCEL
              </button>
            </div>
          </div>
        </CustomModal>

        <StudentDeclaration />
      </div>
    )
  }
}

//export default withRouter(connect(mapStateToProps)(ManageEnrolment))
export default withRouter((ManageEnrolment))